import Cookies from "js-cookie";

export const saveUserToCookies = (user) => {
  Cookies.set("userDetails", JSON.stringify(user), { expires: 7 }); // 7 days expiry
};

export const getUserFromCookies = () => {
  const data = Cookies.get("userDetails");
  return data ? JSON.parse(data) : null;
};

export const clearUserCookies = () => {
  Cookies.remove("userDetails");
};
